export const defaultZoom = 13

export const defaultLatLng = {
  lat: 34.89431171999999,
  lng: 135.8077113,
}

export const defaultClusterRadius = 40
